module.exports = __webpack_public_path__ + "img/1495723369.30de4e87.jpg";